<template>
	<div class="mt-70">
		<app-header></app-header>
        <v-container grid-list-xl mt-2 pa-5>
            <V-layout row wrap justify-center align-center>
                <v-flex lg12 sm12 xs12 md12 class="text-xs-center">
                    <!-- <v-card flat class="mx-5"> -->
                                <div class="font-30">Proof of Enquiries & Trades</div>
                                <div class="font-14 mt-2">We Are Transforming The Future of Financial Markets</div>
                    <!-- </v-card> -->
                </v-flex>
                <v-flex xs12 mt-5>
                    <v-container pa-0 grid-list-xl fluid>
                        <v-layout row wrap>
                            <v-flex xs12 sm6 md4 d-flex>
                                <v-card hover class="px-2 pb-2" height="325px">                                          
                                    <v-card-title class="font-24 primary--text d-flex">
                                        See
                                    </v-card-title>
                                    <v-card-text class="font-italic py-0 font-14">
                                           The unseen
                                    </v-card-text>
                                    <v-card-text>
                                        Trading charts only display the orders that were filled. What’s happening to the majority of the orders that were placed and canceled, the orders that ARE moving the market? Now you see them.
                                    </v-card-text>                        
                                </v-card>
                            </v-flex>
                            <v-flex xs12 sm6 md4 d-flex>
                                <v-card hover class="px-2 pb-2" height="325px">                                          
                                    <v-card-title class="font-24 primary--text d-flex">
                                        True
                                    </v-card-title>
                                    <v-card-text class="font-italic py-0 font-14">
                                           Market Intelligence
                                    </v-card-text>
                                    <v-card-text>
                                        The prices flickering on your computer screen do not tell you the whole story of what is happening in the market. Far from it. It is just a very small tip of the iceberg. It often is what you do not see that will hurt you.
                                    </v-card-text> 
                                    <v-card-text class="pt-0">
                                        If your analysis is only based on the small available final prints of the filled trades, you have been missing 90% of the whole story of the market. Let’s look below the tip of the iceberg!
                                    </v-card-text>                       
                                </v-card>
                            </v-flex>
                            <v-flex xs12 sm6 md4 d-flex>
                                <v-card hover class="px-2 pb-2" height="325px">                                          
                                    <v-card-title class="font-24 primary--text d-flex">
                                        Why bother
                                    </v-card-title>
                                    <v-card-text class="font-italic py-0 font-14">
                                        with the canceled orders?
                                    </v-card-text>
                                    <v-card-text>
                                        The majority of the orders were never filled or never intended to be filled. But they are the ones that truly move the market and the prices that are disclosed to the public.
                                    </v-card-text>                        
                                </v-card>
                            </v-flex>
                            <v-flex xs12 sm6 md4 d-flex>
                                <v-card hover class="px-2 pb-2" height="325px">                                          
                                    <v-card-title class="font-24 primary--text d-flex">
                                        Promoting
                                    </v-card-title>
                                    <v-card-text class="font-italic py-0 font-14">
                                           An Industry-wide Fair Trading Practice
                                    </v-card-text>
                                    <v-card-text>
                                       Through the IOB PoET smart contracts, every order that occurred on the network is recorded automatically on the distributed public ledger, regardless whether it is filled or not.
                                    </v-card-text>                        
                                </v-card>
                            </v-flex>
                            <v-flex xs12 sm6 md4 d-flex>
                                <v-card hover class="px-2 pb-2" height="325px">                                          
                                    <v-card-title class="font-24 primary--text d-flex">
                                        Preventing
                                    </v-card-title>
                                    <v-card-text class="font-italic py-0 font-14">
                                        Price Spoofing
                                    </v-card-text>
                                    <v-card-text>
                                        Spoofing is a disruptive algorithmic trading entity employed by traders to outpace other market participants and to manipulate financial markets.
                                    </v-card-text>                        
                                </v-card>
                            </v-flex>
                            <v-flex xs12 sm6 md4 d-flex>
                                <v-card hover class="px-2 pb-2" height="325px">                                          
                                    <v-card-title class="font-24 primary--text d-flex">
                                        Proof of All Enquiries
                                    </v-card-title>
                                    <v-card-text class="font-italic py-0 font-14">
                                        PoET Addresses The Spoofing Problem
                                    </v-card-text>
                                    <v-card-text>
                                        Recording all orders sent, not only the small fraction of executed orders. Every time an order is sent, it records its wallet address, time (accurate to a nanosecond), quantity, price, instrument, account/wallet ID, exchange(s) it was sent to.
                                    </v-card-text>                        
                                </v-card>
                            </v-flex>
                            <v-flex xs12 sm6 md4 d-flex>
                                <v-card hover class="px-2 pb-2" height="325px">                                          
                                    <v-card-title class="font-24 primary--text d-flex">
                                        Preventing
                                    </v-card-title>
                                    <v-card-text class="font-italic py-0 font-14">
                                        Front Running
                                    </v-card-text>
                                    <v-card-text>
                                       Front-running is the prohibited practice of entering into an order to capitalize on an advance, nonpublic knowledge of a large pending transaction that will influence the price of the underlying security. This is considered a form of market manipulation in many markets.
                                    </v-card-text>                      
                                </v-card>
                            </v-flex>
                            <v-flex xs12 sm6 md4 d-flex>
                                <v-card hover class="px-2 pb-2" height="325px">                                          
                                    <v-card-title class="font-24 primary--text d-flex">
                                        Proof of All Trades
                                    </v-card-title>
                                    <v-card-text class="font-italic py-0 font-14">
                                        Every Trade on An Immutable Distributed Public Ledger
                                    </v-card-text>
                                    <v-card-text>
                                       PoET records all transactions occurred on the network on an immutable public ledger. Every time an order is executed, it records its wallet address, time (accurate to a nanosecond), quantity, price, instrument, account/wallet ID, and exchange(s).
                                    </v-card-text>                        
                                </v-card>
                            </v-flex>
                            <v-flex xs12 sm6 md4 d-flex>
                                <v-card hover class="px-2 pb-2" height="325px">                                          
                                    <v-card-title class="font-24 primary--text d-flex">
                                        Protocol
                                    </v-card-title>
                                    <v-card-text class="font-italic py-0 font-14">
                                        A market transparency protocol
                                    </v-card-text>
                                    <v-card-text>
                                       The market is often manipulated by the unfilled orders.
                                    </v-card-text> 
                                    <v-card-text class="pt-0">
                                       As regulation in the traditional financial markets is tightening the control of various market manipulations, IOB proposes a DLT solution to record every price and order enquiry ever sent – whether filled or not – and every trade ever executed on an immutable distributed public ledger, the IOB Proof of Enquiries & Trades (PoET) protocol.
                                    </v-card-text>                         
                                </v-card>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex xs12 sm6 md12  mt-5>
                                <v-card>
                                    <v-card-text class="mx-3 mb-0 mt-2">
                                        IOB LLC offers market fraud detection products and services (IOB Analytics), coupled with automated trading systems through its structured market data (PoET), a social investment platform (SiP), and trader-generated data integration.Separate products are provided to address the needs of both professional traders (TCS) and Millennial/Gen Z traders (ioBots).
                                    </v-card-text>
                                    <v-card-text class="text-xs-right mt-0">
                                        <v-btn @click="goUserRequest" small color="primary" dark>Submit</v-btn>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                             <v-flex xs12 sm6 md12 mt-5 class="text-lg-right">
                                <div>
                                    <a :href="domainName">
                                        <v-icon color="grey" size="20" >arrow_back</v-icon>	
                                    </a>
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-flex>
            </V-layout>
        </v-container>

	</div>
</template>
<style>

</style>
<script>
	import Vue from 'vue'
    import config from '../../config.js'
    export default {
        data(){
            return{
                domainName: config.ip
                
            }
        },
        created(){
            
        },
        mounted(){
            
        },
        watch:{
            
        },
        methods: {
            goUserRequest() {
                    this.$router.push({ name: 'userRequest' })
            },
            

        },
    }
</script>


// WEBPACK FOOTER //
// Poet.vue?6416c872